import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TransactionHistory').create(({ theme }) => ({
  root: {
    padding: '12px',
    width: '100%',
    height: '100%',
    position: 'relative',
    h1: {
      fontWeight: '450',
      fontSize: '24px',
      color: theme.colors.text.primary,
      textAlign: 'center',
      lineHeight: '30px',
      margin: '0px',
    },
  },

  groupedList: {
    paddingBottom: '24px',
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  dateText: {
    fontFamily: 'Inter',
    fontWeight: '550',
    fontSize: '18px',
    marginTop: '12px',
    color: 'white',
  },

  noPurchases: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontWeight: 350,
    fontSize: '17px',
    textAlign: 'center',
    color: theme.colors.text.secondary,
  },
}))
